<template>
    <div id="app">
        <Header />
        <div id="wrapper">
            <div id="demo-wrapper">
                <h3>Phone Demo</h3>
                <div style="margin-bottom:1rem;font-size:9pt;">Hit Enter to submit your response</div>
                <div id="demo">
                    <img src="../assets/phone.png" />
                    <div id="screen">{{invalid || SMSModule[currentSMSIndex].text}}</div>
                    <input
                        id="input"
                        v-model="response"
                        placeholder="Enter response here"
                        @keydown="handleResponse"
                        :disabled="disableInput"
                    />
                </div>
            </div>
            <div id="table">
                <h3 style="text-align:center; margin-bottom:20px;">Modules</h3>
                <ul class="nav nav-tabs nav-justified">
                    <li class="nav-item">
                        <a
                            :class="['nav-link', currentTab==1 ? 'active' : 'link']"
                            @click="currentTab=1;currentSMSIndex='0';disableInput=false"
                        >SST (Hindi)</a>
                    </li>
                    <li class="nav-item">
                        <a
                            :class="['nav-link', currentTab==2 ? 'active' : 'link']"
                            @click="currentTab=2;currentSMSIndex='0';disableInput=false"
                        >SST (English)</a>
                    </li>
                </ul>
                <div style="max-height:570px;overflow:scroll">
                    <table class="table table-striped" v-if="currentTab==1">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">SMS</th>
                            </tr>
                        </thead>
                        <tbody style="overflow: scroll">
                            <tr v-for="i in mod1" :key="i.index">
                                <th scope="row">{{i.index}}</th>
                                <td>{{i.sms}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="max-height:570px;overflow:scroll">
                    <table class="table table-striped" v-if="currentTab==2">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">SMS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="j in mod2" :key="j.index">
                                <th scope="row">{{j.index}}</th>
                                <td>{{j.sms}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { phoneDemoData, getList } from "../assets/data";
import Header from '@/components/Header';

export default {
    components: {
        Header,
    },
    data() {
        return {
            currentTab: 1,
            currentSMSIndex: "0",
            SMSModule: phoneDemoData,
            invalid: null,
            response: null,
            disableInput: false,
        };
    },
    computed: {
        mod1() {
            return getList(phoneDemoData, "H");
        },
        mod2() {
            return getList(phoneDemoData, "E");
        }
    },
    methods: {
        handleResponse(e) {
            if (e.keyCode == 13) {
                if (!this.response) {
                    return;
                }
                this.invalid = null;
                const formattedResponse = this.response.trim().toUpperCase();
                const responses = this.SMSModule[this.currentSMSIndex]
                    .responses;
                console.log(responses);
                const responseRecorded = responses[formattedResponse];
                this.response = null;
                if (responseRecorded) {
                    if (responseRecorded == "-1") {
                        this.disableInput = true;
                    }
                    this.currentSMSIndex = responseRecorded;
                } else {
                    this.response = null;
                    const available = Object.keys(
                        this.SMSModule[this.currentSMSIndex].responses
                    ).reduce((concat, item) => {
                        if (concat == "") {
                            return concat + item;
                        } else {
                            return concat + ", " + item;
                        }
                    }, "");
                    if (this.currentSMSIndex.includes('E')) {
                        this.invalid = `Invalid response. Available responses: ${available}`;
                    } else {
                        this.invalid = `आपके द्वारा दिया गया उत्तर अमान्य है। उपलब्ध उत्तर: ${available}`;
                    }
                }
            }
        }
    }
};
</script>

<style scoped>
@media screen and (max-width: 1000px) {
    #wrapper {
        padding: 50px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    #table {
        margin-top: 50px;
        width:80%
    }
}
@media screen and (min-width: 1000px) {
    #wrapper {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        height: 100vh;
        overflow: scroll;
    }
    #table {
        margin-bottom: 5px;
        width: 48%;
    }
}
#app {
    display: flex;
    flex-direction: column;
}
#head {
    text-align: center;
}

#demo-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
#demo {
    position: relative;
    display: flex;
    justify-content: center;
    height: 590px;
}
#demo img {
    position: absolute;
    height: 590px;
}

#screen {
    width: 180px;
    height: 240px;
    background-color: white;
    position: absolute;
    top: 48px;
    padding: 10px;
    font-size: 11pt;
}

#input {
    font-size: 11pt;
    position: absolute;
    width: 180px;
    height: 0px;
    top: 295px;
    padding: 9px;
    outline: none;
    font-family: "Noto Sans", sans-serif;
}
#input:disabled {
    background-color: lightgray;
}

#table {
    height: 665px;
    
    /* display: flex;
    flex-direction:column;
    align-items: center; */
}

.link {
    color: blue !important;
    cursor: pointer;
}
</style>